export default Object.freeze({
	Default: 'Default',
	Text: 'Text',
	Image: 'Image',
});
